import { render, staticRenderFns } from "./EmbeddedFormsAppDialog.vue?vue&type=template&id=2f494890&scoped=true&"
import script from "./EmbeddedFormsAppDialog.vue?vue&type=script&lang=js&"
export * from "./EmbeddedFormsAppDialog.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedFormsAppDialog.vue?vue&type=style&index=0&id=2f494890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f494890",
  null
  
)

export default component.exports